export enum MutationsTypes {
  SWITCH_SCORE_HIDE_STATUS = 'switchScoreHideStatus',
}
